import * as actionTypes from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import { ListResults } from '../../common/List/List';
import { CertificateTemplate } from '../../domain/CertificateTemplate';

export const fetchCertificateTemplatesStart = () => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATES_START,
});

export const fetchCertificateTemplatesSuccess = (
  certificateTemplatesList: ListResults<CertificateTemplate>,
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATES_SUCCESS,
  certificateTemplatesList,
});

export const fetchCertificateTemplatesFail = (
  certificateTemplatesListError: HttpError,
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATES_FAIL,
  certificateTemplatesListError,
});

export const fetchDraftCertificateTemplatesStart = () => ({
  type: actionTypes.FETCH_DRAFT_CERTIFICATE_TEMPLATES_START,
});

export const fetchDraftCertificateTemplatesSuccess = (
  draftCertificateTemplatesList: ListResults<CertificateTemplate>,
) => ({
  type: actionTypes.FETCH_DRAFT_CERTIFICATE_TEMPLATES_SUCCESS,
  draftCertificateTemplatesList,
});

export const fetchDraftCertificateTemplatesFail = (
  draftCertificateTemplatesListError: HttpError,
) => ({
  type: actionTypes.FETCH_DRAFT_CERTIFICATE_TEMPLATES_FAIL,
  draftCertificateTemplatesListError,
});

export const fetchCertificateTemplateStart = () => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_START,
});

export const fetchCertificateTemplateSuccess = (
  certificateTemplate: CertificateTemplate,
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_SUCCESS,
  certificateTemplate,
});

export const fetchCertificateTemplateFail = (
  certificateTemplateError: HttpError,
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_FAIL,
  certificateTemplateError,
});

export const fetchIsCertificateTemplateHasSignedOrSentCertificateStart =
  () => ({
    type: actionTypes.FETCH_IS_CERTIFICATE_TEMPLATE_HAS_SIGNED_OR_SENT_CERTIFICATE_START,
  });

export const fetchIsCertificateTemplateHasSignedOrSentCertificateSuccess = (
  isCertificateTemplateHasSignedOrSentCertificate: boolean,
) => ({
  type: actionTypes.FETCH_IS_CERTIFICATE_TEMPLATE_HAS_SIGNED_OR_SENT_CERTIFICATE_SUCCESS,
  isCertificateTemplateHasSignedOrSentCertificate,
});

export const fetchIsCertificateTemplateHasSignedOrSentCertificateFail = (
  isCertificateTemplateHasSignedOrSentCertificateError: HttpError,
) => ({
  type: actionTypes.FETCH_IS_CERTIFICATE_TEMPLATE_HAS_SIGNED_OR_SENT_CERTIFICATE_FAIL,
  isCertificateTemplateHasSignedOrSentCertificateError,
});

export const fetchSentCertificateTemplatesStart = () => ({
  type: actionTypes.FETCH_SENT_CERTIFICATE_TEMPLATES_START,
});

export const fetchSentCertificateTemplatesSuccess = (
  sentCertificateTemplates: ListResults<CertificateTemplate>,
) => ({
  type: actionTypes.FETCH_SENT_CERTIFICATE_TEMPLATES_SUCCESS,
  sentCertificateTemplates,
});

export const fetchSentCertificateTemplatesFail = (
  sentCertificateTemplatesError: HttpError,
) => ({
  type: actionTypes.FETCH_SENT_CERTIFICATE_TEMPLATES_FAIL,
  sentCertificateTemplatesError,
});

export const fetchCertificateTemplateSuggestionsStart = () => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_SUGGESTIONS_START,
});

export const fetchCertificateTemplateSuggestionsSuccess = (
  certificateTemplateSuggestions: CertificateTemplate[],
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_SUGGESTIONS_SUCCESS,
  certificateTemplateSuggestions,
});

export const fetchCertificateTemplateSuggestionsFail = (
  certificateTemplateSuggestionsError: HttpError,
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_SUGGESTIONS_FAIL,
  certificateTemplateSuggestionsError,
});

export const resetCertificateTemplateSuggestions = () => ({
  type: actionTypes.RESET_CERTIFICATE_TEMPLATE_SUGGESTIONS,
});

export const saveCertificateTemplateStart = () => ({
  type: actionTypes.SAVE_CERTIFICATE_TEMPLATE_START,
});

export const saveCertificateTemplateSuccess = (
  certificateTemplate: CertificateTemplate,
) => ({
  type: actionTypes.SAVE_CERTIFICATE_TEMPLATE_SUCCESS,
  certificateTemplate,
});

export const saveCertificateTemplateFail = (
  saveCertificateTemplateError: HttpError,
) => ({
  type: actionTypes.SAVE_CERTIFICATE_TEMPLATE_FAIL,
  saveCertificateTemplateError,
});

export const saveCertificateTemplateThumbnailStart = () => ({
  type: actionTypes.SAVE_CERTIFICATE_TEMPLATE_THUMBNAIL_START,
});

export const saveCertificateTemplateThumbnailSuccess = (
  certificateTemplate: CertificateTemplate,
) => ({
  type: actionTypes.SAVE_CERTIFICATE_TEMPLATE_THUMBNAIL_SUCCESS,
  certificateTemplate,
});

export const saveCertificateTemplateThumbnailFail = (
  saveCertificateTemplateThumbnailError: HttpError,
) => ({
  type: actionTypes.SAVE_CERTIFICATE_TEMPLATE_THUMBNAIL_FAIL,
  saveCertificateTemplateThumbnailError,
});

export const createCertificateNumbersStart = () => ({
  type: actionTypes.CREATE_CERTIFICATE_NUMBERS_START,
});

export const createCertificateNumbersSuccess = (
  certificateTemplate: CertificateTemplate,
) => ({
  type: actionTypes.CREATE_CERTIFICATE_NUMBERS_SUCCESS,
  certificateTemplate,
});

export const createCertificateNumbersFail = (
  createCertificateNumbersError: HttpError,
) => ({
  type: actionTypes.CREATE_CERTIFICATE_NUMBERS_FAIL,
  createCertificateNumbersError,
});

export const createCustomAttributeStart = () => ({
  type: actionTypes.CREATE_CUSTOM_ATTRIBUTE_START,
});

export const createCustomAttributeSuccess = (
  certificateTemplate: CertificateTemplate,
) => ({
  type: actionTypes.CREATE_CUSTOM_ATTRIBUTE_SUCCESS,
  certificateTemplate,
});

export const createCustomAttributeFail = (
  createCustomAttributeError: HttpError,
) => ({
  type: actionTypes.CREATE_CUSTOM_ATTRIBUTE_FAIL,
  createCustomAttributeError,
});

export const deleteCertificateTemplateStart = () => ({
  type: actionTypes.DELETE_CERTIFICATE_TEMPLATE_START,
});

export const deleteCertificateTemplateSuccess = () => ({
  type: actionTypes.DELETE_CERTIFICATE_TEMPLATE_SUCCESS,
});

export const deleteCertificateTemplateFail = (
  certificateTemplateDeleteError: HttpError,
) => ({
  type: actionTypes.DELETE_CERTIFICATE_TEMPLATE_FAIL,
  certificateTemplateDeleteError,
});

export const updateCertificateTemplateStart = () => ({
  type: actionTypes.UPDATE_CERTIFICATE_TEMPLATE_START,
});

export const updateCertificateTemplateSuccess = () => ({
  type: actionTypes.UPDATE_CERTIFICATE_TEMPLATE_SUCCESS,
});

export const updateCertificateTemplateFail = (
  certificateTemplateUpdateError: HttpError,
) => ({
  type: actionTypes.UPDATE_CERTIFICATE_TEMPLATE_FAIL,
  certificateTemplateUpdateError,
});

export const createCertificateTemplateCopyStart = () => ({
  type: actionTypes.CREATE_CERTIFICATE_TEMPLATE_COPY_START,
});

export const createCertificateTemplateCopySuccess = (
  certificateTemplateCopy: CertificateTemplate,
) => ({
  type: actionTypes.CREATE_CERTIFICATE_TEMPLATE_COPY_SUCCESS,
  certificateTemplateCopy,
});

export const createCertificateTemplateCopyFail = (
  createCertificateTemplateCopyError: HttpError,
) => ({
  type: actionTypes.CREATE_CERTIFICATE_TEMPLATE_COPY_FAIL,
  createCertificateTemplateCopyError,
});

export const toggleCertificateTemplateStatusStart = () => ({
  type: actionTypes.TOGGLE_CERTIFICATE_TEMPLATE_STATUS_START,
});

export const toggleCertificateTemplateStatusSuccess = () => ({
  type: actionTypes.TOGGLE_CERTIFICATE_TEMPLATE_STATUS_SUCCESS,
});

export const toggleCertificateTemplateStatusFail = (
  unsectionedCertificatesError: HttpError,
) => ({
  type: actionTypes.TOGGLE_CERTIFICATE_TEMPLATE_STATUS_FAIL,
  unsectionedCertificatesError,
});

export const fetchUnsectionedCertificatesStart = () => ({
  type: actionTypes.FETCH_UNSECTIONED_CERTIFICATES_START,
});

export const fetchUnsectionedCertificatesSuccess = (
  unsectionedCertificates: CertificateTemplate[],
) => ({
  type: actionTypes.FETCH_UNSECTIONED_CERTIFICATES_SUCCESS,
  unsectionedCertificates,
});

export const fetchUnsectionedCertificatesFail = (
  unsectionedCertificatesError: HttpError,
) => ({
  type: actionTypes.FETCH_UNSECTIONED_CERTIFICATES_FAIL,
  unsectionedCertificatesError,
});

export const replaceCertificateImageStart = () => ({
  type: actionTypes.REPLACE_CERTIFICATE_IMAGE_START,
});

export const replaceCertificateImageSuccess = (
  certificateTemplate: CertificateTemplate,
) => ({
  type: actionTypes.REPLACE_CERTIFICATE_IMAGE_SUCCESS,
  certificateTemplate,
});

export const replaceCertificateImageFail = (
  replaceCertificateImageError: HttpError,
) => ({
  type: actionTypes.REPLACE_CERTIFICATE_IMAGE_FAIL,
  replaceCertificateImageError,
});

export const fetchSectionCertificateTemplatesStart = () => ({
  type: actionTypes.FETCH_SECTION_CERTIFICATE_TEMPLATES_START,
});

export const fetchSectionCertificateTemplatesSuccess = (
  sectionCertificateTemplates: CertificateTemplate[],
) => ({
  type: actionTypes.FETCH_SECTION_CERTIFICATE_TEMPLATES_SUCCESS,
  sectionCertificateTemplates,
});

export const fetchSectionCertificateTemplatesFail = (
  sectionCertificateTemplatesError: HttpError,
) => ({
  type: actionTypes.FETCH_SECTION_CERTIFICATE_TEMPLATES_FAIL,
  sectionCertificateTemplatesError,
});

export const setShowCertificateTemplateHasEditedNotSentCertificatesModal = (
  showCertificateTemplateHasEditedNotSentCertificatesModal: boolean,
) => ({
  type: actionTypes.SET_SHOW_CERTIFICATE_TEMPLATE_HAS_EDITED_NOT_SENT_CERTIFICATES_MODAL,
  showCertificateTemplateHasEditedNotSentCertificatesModal,
});

export const fetchCertificateTemplateWithEditedNotSentCertificatesStart =
  () => ({
    type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_WITH_EDITED_NOT_SENT_CERTIFICATES_START,
  });

export const fetchCertificateTemplateWithEditedNotSentCertificatesSuccess = (
  certificateTemplateWithEditedNotSentCertificates: CertificateTemplate[],
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_WITH_EDITED_NOT_SENT_CERTIFICATES_SUCCESS,
  certificateTemplateWithEditedNotSentCertificates,
});

export const fetchCertificateTemplateWithEditedNotSentCertificatesFail = (
  certificateTemplateWithEditedNotSentCertificatesError: HttpError,
) => ({
  type: actionTypes.FETCH_CERTIFICATE_TEMPLATE_WITH_EDITED_NOT_SENT_CERTIFICATES_FAIL,
  certificateTemplateWithEditedNotSentCertificatesError,
});

export const resetIsCertificateTemplateHasSignedOrSentCertificateStore =
  () => ({
    type: actionTypes.RESET_IS_CERTIFICATE_TEMPLATE_HAS_SIGNED_OR_SENT_CERTIFICATE_STORE,
  });

export const resetCertificateTemplateStore = () => ({
  type: actionTypes.RESET_CERTIFICATE_TEMPLATE_STORE,
});

export const resetCropImageStore = () => ({
  type: actionTypes.RESET_CROP_IMAGE_STORE,
});

export const resetCertificateNumberStore = () => ({
  type: actionTypes.RESET_CERTIFICATE_NUMBER_STORE,
});

export const resetCertificateTemplateUpdateStore = () => ({
  type: actionTypes.RESET_CERTIFICATE_TEMPLATE_UPDATE_STORE,
});

export const logout = () => ({
  type: actionTypes.LOGOUT,
});
